import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import SecurityPermissionsImage from '@atlassian/jira-illustrations/src/ui/adg5/brand/spot/empty-state/components/security-permissions/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import type { EmptyStateProps } from './types.tsx';

export const GenericEmptyState = ({ header, description, link }: EmptyStateProps) => {
	const { formatMessage } = useIntl();

	return (
		<Stack alignInline="center">
			<Stack xcss={stackStyle} space="space.200" alignInline="center">
				<Box xcss={imageStyle}>
					<SecurityPermissionsImage alt={formatMessage(messages.securityPermissionsImageAlt)} />
				</Box>
				<Heading size="small">{header}</Heading>
				<Text align="center">{description}</Text>
				{link}
			</Stack>
		</Stack>
	);
};

const imageStyle = xcss({
	height: '160px',
	width: '160px',
});

const stackStyle = xcss({
	width: '85%',
});
